'use client';

import { ReactNode, useCallback } from 'react';
import { useGlobalDialog } from './global-dialog-context';

interface UseDialogOptions {
  content: ReactNode;
  className?: string;
  preventOutsideClose?: boolean;
}

export function useDialog() {
  const { openDialog, closeDialog } = useGlobalDialog();

  const open = useCallback(
    (options: UseDialogOptions) => {
      openDialog(options);
    },
    [openDialog]
  );

  return {
    open,
    close: closeDialog,
  };
}
